"use client";

import type { LeagueEpisodeTableRow, EpisodeSort } from "./episode-values";
import * as stylex from "@stylexjs/stylex";
import { styles } from "./episodes.styles";
import { SortSelect } from "./episode-sort-select";
import { EpisodeRows } from "./episode-rows";

type LeagueEpisodesTableProps = {
  readonly rows: readonly LeagueEpisodeTableRow[];
  readonly allEpisodesHref: string | null;
  readonly sort: EpisodeSort;
  readonly onSortChange: (sort: EpisodeSort) => void;
  readonly footer: string;
};

export function LeagueEpisodesTable({
  rows,
  allEpisodesHref,
  sort,
  onSortChange,
  footer,
}: LeagueEpisodesTableProps) {
  return (
    <div {...stylex.props(styles.root)}>
      <SortSelect sort={sort} onChange={onSortChange} />
      <EpisodeRows rows={rows} kind="league" />
      <div {...stylex.props(styles.foot)}>
        <span>{footer}</span>
        {allEpisodesHref ? (
          <a href={allEpisodesHref} {...stylex.props(styles.more)}>
            All episodes ›
          </a>
        ) : null}
      </div>
    </div>
  );
}
